import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function Layout() {
  const location = useLocation();
  const overlay = location.pathname === "/";

  useEffect(() => {
    if (!overlay) {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [location.pathname, overlay]);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar overlay={overlay} />
      <main className={`flex-1 ${overlay ? "" : "pt-16 md:pt-[68px]"}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}